var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 39.5C77 49.4456 73.0491 58.9839 66.0165 66.0165C58.9839 73.0491 49.4456 77 39.5 77C29.5544 77 20.0161 73.0491 12.9835 66.0165C5.95088 58.9839 2 49.4456 2 39.5M77 39.5C77 29.5544 73.0491 20.0161 66.0165 12.9835C58.9839 5.95088 49.4456 2 39.5 2C29.5544 2 20.0161 5.95088 12.9835 12.9835C5.95088 20.0161 2 29.5544 2 39.5M77 39.5H2",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9228 39.5C53.2144 53.2134 48.1633 66.3462 39.4997 77C30.8362 66.3462 25.7851 53.2134 25.0767 39.5C25.7851 25.7866 30.8362 12.6538 39.4997 2C48.1633 12.6538 53.2144 25.7866 53.9228 39.5Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb2);
export default __webpack_public_path__ + "static/media/web (2).0644033a650f10ee45d031f4467ed7c9.svg";
export { ForwardRef as ReactComponent };